import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { DateUtil } from '@partners/utils';
import { IDateRangeValidationHandler, TValidatorError } from '../../model';

export function dateRangeValidator(args: IDateRangeValidationHandler<string>): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const { value, invalid } = control;
    const { min, max, baseYear } = args;

    if (!value) return null;
    if (invalid) return null;

    const isValid = DateUtil.isDateInRange(value, { min, max, baseYear });

    if (!isValid) {
      const vldResponse: TValidatorError = { dateRange: value };
      return vldResponse;
    }

    return null;
  };
}
